import { TableCard } from '../../../../components'
import { RelatorioNpsData } from './components/data/RelatorioNpsData'
import { RelatorioNpsListHeader } from './components/header/RelatorioNpsListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'

// Filtros no card de cima; o resumo (um card por categoria) e os comentários logo abaixo.
const RelatorioNpsList = () => (
  <>
    <TableCard className='mb-6'>
      <RelatorioNpsListHeader />
    </TableCard>
    <RelatorioNpsData />
  </>
)

export const RelatorioNpsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <RelatorioNpsList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
